// extracted by mini-css-extract-plugin
export var container = "Project-module--container--1Dj5D";
export var topContainer = "Project-module--topContainer--5U31E";
export var bottomContainer = "Project-module--bottomContainer--2jgOX";
export var imageContainer = "Project-module--imageContainer--3y6Zp";
export var blurContainer = "Project-module--blurContainer--2S_Dk";
export var linksContainer = "Project-module--linksContainer--3HQpQ";
export var link = "Project-module--link--3XVUD";
export var linkIcon = "Project-module--linkIcon--_77Qd";
export var image = "Project-module--image--GI7PZ";
export var projectTitle = "Project-module--projectTitle--huhJY";
export var description = "Project-module--description--3JgAy";
export var labelsContainer = "Project-module--labelsContainer--3eVmj";
export var label = "Project-module--label--1TgaJ";